<template>
  <div>
    <p v-if="resultPayment.success">
      {{ resultPayment.item }}
    </p>
    <p v-else>
      {{ resultPayment.error.message }}
    </p>
    <!-- <ul>
      <li class="success">
        <div class="icon">✓</div>
        <div class="title">Informations vérifiées</div>
      </li>
      <li class="success">
        <div class="icon">✓</div>
        <div class="title">Paiement effectué</div>
      </li>
      <li :class="['current', currentState.class]">
        <div class="icon">{{ currentState.icon }}</div>
        <div class="title">{{ currentState.title }}</div>
      </li>
    </ul> -->
  </div>
</template>

<script>

export default {
  props: {
    resultPayment: Object
  },
  data () {
    return {
      status: [
        {
          code: null,
          title: 'En attente du résultat',
          icon: '⭮'
        },
        {
          code: 0,
          title: 'En attente du résultat',
          icon: '⭮'
        },
        {
          code: 1,
          title: 'Paiement effectué',
          icon: '✓',
          class: 'success'
        },
        {
          code: 2,
          title: 'Paiement annulé',
          icon: '✗',
          class: 'error'
        },
        {
          code: 3,
          title: 'Paiement refusé',
          icon: '✗',
          class: 'error'
        },
        {
          code: -1,
          title: 'État inconnu',
          icon: '?',
          class: 'error'
        }
      ]
    }
  },
  computed: {
    currentState () {
      let currentState = this.status.find(state => state.code === this.resultPayment.status)
      currentState = !currentState ? this.status.find(state => state.code === -1) : currentState
      return currentState
    }
  }
}
</script>

<style scoped>
p {
  text-align: left;
}

ul {
  margin: 2rem;
  list-style: none;
}

li {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  vertical-align: center;
  padding-bottom: 2rem;
  border-left: 2px solid rgb(110, 110, 110);
}

li:last-child {
  padding-bottom: 0;
}

li.success {
  border-color: rgb(93, 163, 93);
}

/* Contenu des items */

li div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: rgb(110, 110, 110);
}

li div.icon {
  padding: 4px;
  width: 28px;
  height: 28px;
  font-weight: bold;
  border: 2px solid rgb(110, 110, 110);
  background: white;
  border-radius: 50%;
  transform: translateX(-21px);
}

li div.title {
  margin-left: .5rem;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: -.05rem;
}

li.success div {
  color: rgb(93, 163, 93);
  border-color: rgb(93, 163, 93);
}

li.error div {
  color: rgb(163, 93, 93);
  border-color: rgb(163, 93, 93);
}

@media (max-width: 1000px) {
  ul {
    margin: .5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentStatus.vue